import { startInactivityMonitor, clearInactivityTimer } from '../url-config/inactivity-monitor';

const moveWidgetUp = (pixels) => {
    const iFrameId = 'OPLWCI';
    const moveElement = (id, pixels) => {
        const style = document.createElement('style');
        style.innerHTML = `
        .up${pixels} {
            bottom: ${pixels}px !important;
            }
            `;
        document.head.appendChild(style);

        setTimeout(() => {
            const element = document.getElementById(id);
            element && element.classList.add(`up${pixels}`);
        }, 500);
    };

    if (!document.getElementById(iFrameId)) {
        document.addEventListener('WCIFrameLoaded', () => {
            moveElement(iFrameId, pixels);
        });
    } else {
        moveElement(iFrameId, pixels);
    }
};

const inviteHandler = (config) => {
    clearInactivityTimer();
    if (!config) {
        window.WC.close();
        return;
    }

    if (config.chatInviteIconOptions?.marginBottom) {
        moveWidgetUp(config.chatInviteIconOptions.marginBottom);
    }
    window.WC.open(config);
    startInactivityMonitor(config, (config) => {
        let inactiveConfig = {
            ...config
        };
        inactiveConfig.chatInviteIconOptions.showAfter = 0;
        inactiveConfig.chatInviteIconOptions.hideAfter = 0;
        inactiveConfig.chatInviteIconOptions.tipOptions.showAfter = 0;
        inactiveConfig.chatInviteIconOptions.tipOptions.hideAfter = 0;
        inactiveConfig.chatInviteIconOptions.tipOptions.inactiveShowAfter = 0;
        window.WC.open({
            ...inactiveConfig
        });
    });
};

export { inviteHandler };
